import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const inviteMentor = async data => {
  const token = getToken()
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/growsmart/invite-mentor`,
    data: { token, ...data }
  })

  return response.data
}

export const declineInvite = async data => {
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/growsmart/decline-invite`,
    data
  })

  return response.data
}

export const fetchRegistrations = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/registrations`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchSponsorship = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/sponsorships/${data.id}`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchSponsorships = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/sponsorships`, {
    params: { ...data, token }
  })

  return response.data
}

export const createSponsorship = async data => {
  const token = getToken()
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/growsmart/sponsorships`,
    data: { ...data, token }
  })

  return response.data
}

export const updateSponsorship = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/sponsorships/${data.id}`,
    data: { ...data, token }
  })

  return response.data
}

export const deleteSponsorship = async id => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/growsmart/sponsorships/${id}`, {
    data: { token, id }
  })
  return response
}

export const fetchScholarship = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/scholarships/${data.id}`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchScholarships = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/scholarships`, {
    params: { ...data, token }
  })

  return response.data
}

export const createScholarship = async data => {
  const token = getToken()
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/growsmart/scholarships`,
    data: { ...data, token }
  })

  return response.data
}

export const updateScholarship = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/scholarships/${data.id}`,
    data: { ...data, token }
  })

  return response.data
}

export const updateScholarshipApplication = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/scholarships/applications/${data.get('id')}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}

export const fetchScholarshipApplication = async data => {
  const token = getToken()
  const response = await axios.get(
    `${baseUrl}/growsmart/scholarship-applications/${data.scholarshipApplicationId}`,
    {
      params: { ...data, token }
    }
  )

  return response.data
}

export const fetchScholarshipApplications = async data => {
  const token = getToken()
  const response = await axios.get(
    `${baseUrl}/growsmart/scholarships/${data.scholarshipId}/applications`,
    {
      params: { ...data, token }
    }
  )

  return response.data
}

export const applyToScholarship = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios.post(`${baseUrl}/growsmart/scholarships/apply`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })

  return response.data
}

export const deleteScholarship = async id => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/growsmart/scholarships/${id}`, {
    data: { token, id }
  })
  return response
}

export const deleteScholarshipApplication = async id => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/growsmart/scholarships/applications/${id}`, {
    data: { token, id }
  })
  return response
}

export const fetchSchoolsForProvince = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/schools-for-province`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchHardcopySubmissions = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/hardcopy-submissions`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchDistricts = async () => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/districts`, {
    params: { token }
  })

  return response.data
}

export const fetchRsvps = async () => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/rsvps`, {
    params: { token }
  })

  return response.data
}

export const fetchEnrolment = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/enrolment`, {
    params: { ...data, token }
  })

  return response.data
}

export const fetchEnrolments = async query => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/growsmart/enrolments`, {
    params: { ...query, token }
  })

  return response.data
}

export const bulkUpdateHardcopySubmissions = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/update-hardcopy-submissions`,
    data: { ...data, token }
  })

  return response.data
}

export const bulkUpdateSchools = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/update-schools`,
    data: { ...data, token }
  })

  return response.data
}

export const updateRsvp = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/rsvps/${data.id}`,
    data: { ...data, token }
  })

  return response.data
}

export const manualRegistration = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/manually-register`,
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    data
  })

  return response.data
}

export const updateEnrolment = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/enrolments/${data.get('id')}`,
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    data
  })

  return response.data
}

export const updateEnrolmentAsParent = async data => {
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/parent-update-enrolment/${data.id}`,
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    data
  })

  return response.data
}

export const updateRegistration = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/registrations/${data.id}`,
    data: { ...data, token }
  })

  return response.data
}

export const closeRound = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/close-round`,
    data: { ...data, token }
  })

  return response.data
}

export const updateRoundMarks = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/update-round-marks`,
    data: { ...data, token }
  })

  return response.data
}

export const launchComp = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/launch-competition`,
    data: { ...data, token }
  })

  return response.data
}

export const importEvents = async data => {
  const token = getToken()
  const response = await axios({
    method: 'put',
    url: `${baseUrl}/growsmart/import-events`,
    data: { ...data, token }
  })

  return response.data
}
